<div class="container-treetable" style="height: 100%; display: flex; flex-direction: column;">
  <div style="flex: 1; overflow: auto;">
    <p-treeTable #tt [value]="nodes" [scrollable]="true" [tableStyle]="{'min-width':'50rem'}" selectionMode="single"
      [filterMode]="filterMode">

      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          @for(col of leafs; track $index){
          <th class="tt-header">
            <div class="header-cell">
              <span class="header-title">{{ col.header }}</span>

              <input class="input-filter" type="text" pInputText
                (input)="tt.filter($event.target.value, col.header, 'contains')"
                [placeholder]="filterBy + ' ' + col.header" />
            </div>
          </th>
          }

        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode">
          @for(col of leafs; track $index){
          <td class="tt-cell-top" (click)="handleClick(rowData[col.field], col.field)">

            <!-- Solo en la primera columna mostramos el toggler -->
            @if($index === 0){
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            }
            <!-- Mostrar header opcional -->
            @if(showField){
            <strong>{{ col.header }} - </strong>
            }
            {{ rowData[col.field] }}
          </td>
          }
        </tr>
      </ng-template>

    </p-treeTable>
  </div>
</div>